import { useQuery } from 'react-query'
import { getCashBoxMessages } from 'services/messages'

export default function useGetCashboxMessages() {
    const { data } = useQuery(['cashbox-messages'], getCashBoxMessages, {
        staleTime: 30_000,
    })
    return { cashboxData: data }
}
